import theme from '../components/theme'

export default theme
